// The support scale + door vocabulary, locked to the NationBuilder 1-5 values so
// colors match across the door screen, the list, the map, and the export.

export interface SupportLevel {
  value: 1 | 2 | 3 | 4 | 5;
  label: string;
  short: string;
  cls: string; // CSS class for the solid button (sv1..sv5)
  dot: string; // CSS class for the support dot (s1..s5)
}

export const SUPPORT_LEVELS: SupportLevel[] = [
  { value: 1, label: 'Strong support', short: 'Strong', cls: 'sv1', dot: 's1' },
  { value: 2, label: 'Lean support', short: 'Lean', cls: 'sv2', dot: 's2' },
  { value: 3, label: 'Undecided', short: 'Undecided', cls: 'sv3', dot: 's3' },
  { value: 4, label: 'Lean opposed', short: 'Lean opp.', cls: 'sv4', dot: 's4' },
  { value: 5, label: 'Strong opposed', short: 'Strong opp.', cls: 'sv5', dot: 's5' },
];

export function supportDotClass(level: number | null | undefined, visited: boolean): string {
  if (level && level >= 1 && level <= 5) return `s${level}`;
  return visited ? 'sd' : '';
}

// Dispositions are NOT support levels. "not_home" is the common 1-tap terminal action.
export interface Disposition {
  value: string;
  label: string;
  primary?: boolean;
}
// Tight, fixed set (MiniVAN-style) — do not let this sprawl.
export const DISPOSITIONS: Disposition[] = [
  { value: 'not_home', label: 'Not home', primary: true },
  { value: 'refused', label: 'Refused' },
  { value: 'moved', label: 'Moved' },
  { value: 'no_such_address', label: 'No such address' },
  { value: 'inaccessible', label: 'Inaccessible' },
  { value: 'language_barrier', label: 'Language barrier' },
  { value: 'do_not_contact', label: 'Do not contact' },
];

export const ISSUE_TAGS = [
  'safety',
  'property tax',
  'housing',
  'permits',
  'transit',
  'transparency',
  'other',
] as const;

/** Pick black or white text for legibility on an arbitrary candidate colour. */
export function readableInk(hex: string): string {
  const h = hex.replace('#', '');
  if (h.length < 6) return '#1a1a1a';
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? '#1a1a1a' : '#ffffff';
}

export const CONSENT_VERSION = '2026-09-pipa-v1';
export const PITCH_SCRIPT =
  'Hi, I’m a volunteer with a group of independent candidates for Victoria City Council. ' +
  'We’re coordinating but each runs their own campaign. Quick question — are there local ' +
  'issues you care about this election? (Consent: we’re a group of candidates and we share ' +
  'what you tell us among the group so we don’t knock twice.)';
